var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',{staticStyle:{"color":"#7A7A7A"}},[_vm._t("thead")],2),_c('tbody',[_vm._t("tbody")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }